import axiosInstance from '@/store/axios'
import { rejectError } from '../helper'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    logs ({ commit }, params) {
      return axiosInstance.get('/api/v1/logs', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    groupedLogs ({ commit }, params) {
      return axiosInstance.get('/api/v1/grouped-logs', { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    getEventDetails ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/logs/${params.id}/info`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
    // eslint-disable-next-line no-unused-vars
    viewReport ({ commit }, params) {
      return axiosInstance.get('/api/v1/view-report', { params: params, responseType: 'blob' })
        .then((result) => result)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getEventAd ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/logs/${params.id}/ad`, { params })
        .then((result) => result.data.data)
        .catch((error) => rejectError(error))
    },
  },
}
